/** @jsx jsx */
import * as React from "react";
import { AppConstants } from "../../utils/AppConstants";
import { ISelectOption } from "../../models/Roster/IRosterTimeItervals";
import AppUtils from "../../utils/AppUtils";
import * as moment from "moment";;
import LocalStorageUtils from "../../utils/LocalStorageUtils";
import { EventNames } from "../../utils/EventTrackerConstants";
import { rosterStyles } from "../../styles/roster/mobile/roster";
import { css, jsx } from "@emotion/core";
import Select, { StylesConfig } from "react-select";
import { WarningInline } from "../common/WarningInline";
export enum AM_PM {
    AM = "AM",
    PM = "PM",
}
enum CHANGE_KEYS {
    START_MERIDIAN = "startMeridian",
    END_MERIDIAN = "endMeridian",
    START_HOUR = "startHour",
    END_HOUR = "endHour",
    START_MINUTE = "startMinute",
    END_MINUTE = "endMinute"
}
interface IRosterTimeSelectorProps {
    index: number;
    shiftTimeChangeHandler(index: number, val: string, key: "startTime" | "endTime"): void;
    deleteShift(index: number): void;
    date: string;
    value: {
        startTimeForEdit: string,
        endTimeForEdit: string
    }
    widgetName?: string;
    isDefaultWorkingHoursAction?: boolean;
}

interface IRosterTimeSelectorState {
    selectedValues: {
        startMeridian: AM_PM;
        endMeridian: AM_PM;
        startHour: string;
        endHour: string;
        startMinute: string;
        endMinute: string;
    },
    errMsg: string;
    // islateNightShift: boolean;
}

//styles for the dropdown
let customDropdownStyles: StylesConfig = {
    control: styles => ({
        ...styles,
        borderRadius: 0,
        border: 0,
        borderBottom: "solid 1px #b6c6d7",
        width: "58px",
        boxShadow: "none",
        '&:hover': {
            boxShadow: 0,
            borderBottom: "solid 1px #e4306e"
        }
    }),
    indicatorSeparator: styles => ({
        ...styles,
        display: "none"
    }),
    singleValue: styles => ({
        ...styles,
        fontFamily: "BrandonTextWeb-Regular",
        fontSize: 14,
        color: "rgb(0, 0, 0)"
    }),
    indicatorsContainer: styles => ({
        ...styles,
        padding: 0
    }),
    menu: styles => ({
        ...styles,
        width: "78px"
    }),
    valueContainer: styles => ({
        ...styles,
        padding: 0
    }),
    dropdownIndicator: styles => ({
        ...styles,
        padding: 0
    }),
    menuPortal: styles => ({
        ...styles,
        zIndex: 9999
    })
};


export class RosterTimeSelector extends React.Component<IRosterTimeSelectorProps, IRosterTimeSelectorState>{
    constructor(props: IRosterTimeSelectorProps) {
        super(props);
        this.state = {
            selectedValues: {
                startMeridian: null,
                endMeridian: null,
                startHour: null,
                endHour: null,
                startMinute: null,
                endMinute: null
            },
            errMsg: null,
            // islateNightShift: null
        }
        this.shiftTimeChangeHandler = this.shiftTimeChangeHandler.bind(this);
        // this.isSlotInValid = this.isSlotInValid.bind(this);
        // this.checkAndShowLateNightShiftMessage = this.checkAndShowLateNightShiftMessage.bind(this);
    }

    private hourSelector = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    private minuteSelector = ["00", "15", "30", "45"];
    private amPmSelector = [AM_PM.AM, AM_PM.PM];

    componentDidMount() {
        if (this.props.value) {
            this.getTimeValues(this.props.value);
        }
    }

    getTimeValues = (value: any) => {
        const { startTimeForEdit, endTimeForEdit } = value;
        if (startTimeForEdit) {
            const [startHour, startMinute, startMeridian] = moment(startTimeForEdit, "HH:mm").format("hh mm A").split(" ");
            this.setState(ps => ({ selectedValues: { ...ps.selectedValues, startHour, startMinute, startMeridian: startMeridian as AM_PM } }));
        }

        if (endTimeForEdit) {
            const [endHour, endMinute, endMeridian] = endTimeForEdit && moment(endTimeForEdit, "HH:mm").format("hh mm A").split(" ");
            this.setState(ps => ({ selectedValues: { ...ps.selectedValues, endMeridian: endMeridian as AM_PM, endMinute, endHour } }));
        }
    }

    getTrackComponentName() {
        const { isDefaultWorkingHoursAction } = this.props;
        return isDefaultWorkingHoursAction ? EventNames.Automated_Working_Hours : EventNames.Working_Hours;
    }


    private shiftTimeChangeHandler = (selectedOption: ISelectOption, actionMeta: any) => {
        const key = actionMeta.name;
        LocalStorageUtils.setClickEvents({ field: key, widget: this.props.widgetName, flow: this.getTrackComponentName(), section: this.getTrackComponentName() })
        const currentState = { ...this.state.selectedValues };
        (currentState as any)[key] = selectedOption.value;
        this.setState({ selectedValues: { ...currentState } }, () => {
            // const invalidSlotMessage: string = this.isSlotInValid();
            // this.setState({ errMsg: invalidSlotMessage });
            // if (invalidSlotMessage === AppConstants.ROSTER_MESSAGES.NULL_SHIFTS) {
            //     return null;
            // }
            const { startMeridian, endMeridian, startHour, startMinute, endHour, endMinute } = this.state.selectedValues;
            const startTimeValue: string = startMeridian && startHour && startMinute && AppUtils.convert12HrsTo24HrsTimeFormat(startHour, startMinute, startMeridian);
            const endTimeValue: string = endMeridian && endHour && endMinute && AppUtils.convert12HrsTo24HrsTimeFormat(endHour, endMinute, endMeridian);
            const { shiftTimeChangeHandler, index } = this.props;
            shiftTimeChangeHandler(index, startTimeValue, "startTime");
            shiftTimeChangeHandler(index, endTimeValue, "endTime");
        });

    }

    // private checkAndShowLateNightShiftMessage(): void {
    //     const { endMeridian, startMeridian, startHour, startMinute, endHour, endMinute } = this.state.selectedValues;
    //     if (endMeridian && startMeridian && startHour && endHour && startMinute && endMinute) {
    //         if (((Number(startHour)) >= 1 && (Number(startHour)) <= 6 && startMeridian === AM_PM.AM) || ((Number(endHour)) >= 1 && (Number(endHour)) <= 6 && endMeridian === AM_PM.AM)) {
    //             this.setState({ islateNightShift: true });
    //         } else {
    //             this.setState({ islateNightShift: false });
    //         }
    //     }
    // }

    // private isSlotInValid(): string {
    //     const { startMeridian, endMeridian, startHour, endHour, startMinute, endMinute } = this.state.selectedValues;
    //     const { date, isDefaultWorkingHoursAction } = this.props;
    //     const allValues = Object.values(this.state.selectedValues);
    //     for (let count = 0; count < allValues.length; count++) {
    //         if (!allValues[count])
    //             return AppConstants.ROSTER_MESSAGES.NULL_SHIFTS;
    //     }
    //     const editedDate = isDefaultWorkingHoursAction ? moment(new Date(), AppConstants.dateFormat).valueOf() : moment(date, AppConstants.dateFormat).valueOf();
    //     const startTimeStamp: number = AppUtils.getEpochFromDateAndTime(editedDate, AppUtils.convert12HrsTo24HrsTimeFormat(startHour, startMinute, startMeridian));
    //     const endTimeStamp: number = AppUtils.getEpochFromDateAndTime(editedDate, AppUtils.convert12HrsTo24HrsTimeFormat(endHour, endMinute, endMeridian));
    //     if (endTimeStamp < startTimeStamp) {
    //         return AppConstants.ROSTER_MESSAGES.INVALID_INTERVAL;
    //     }
    //     if (startTimeStamp === endTimeStamp) {
    //         return AppConstants.ROSTER_MESSAGES.SAME_TIME;
    //     }
    //     return null;
    // }

    deleteShift = (index: number) => {
        LocalStorageUtils.setClickEvents({ field: EventNames.Delete, widget: this.props.widgetName, flow: this.getTrackComponentName(), section: this.getTrackComponentName() });
        this.props.deleteShift(index);
    }

    formatOptions = (options: any[]) => {
        return options.map(option => ({ label: option, value: option }));
    }

    formatSingleValue = (val: any) => {
        return ({ label: val, value: val })
    }

    render() {
        const { index } = this.props;
        const { selectedValues: { startMeridian, endMeridian, startHour, startMinute, endHour, endMinute }, errMsg } = this.state;
        const isMobile: boolean = AppUtils.getIsMobile();
        return (
            <React.Fragment key={index}>
                <table>
                    <tbody>
                        <tr css={isMobile ? rosterStyles.rosterModalMobileTimeSelectors : rosterStyles.rosterModalTimeSelectors}>
                            <td>
                                <label>START TIME</label>
                                <div css={rosterStyles.timeSelectionWrapper}>
                                    <Select onChange={this.shiftTimeChangeHandler} options={this.formatOptions(this.hourSelector)} placeholder="Hour" name={CHANGE_KEYS.START_HOUR}
                                        value={startHour ? this.formatSingleValue(startHour) : null} styles={customDropdownStyles} menuPortalTarget={isMobile ? null : document.body}
                                    />
                                    <Select onChange={this.shiftTimeChangeHandler} options={this.formatOptions(this.minuteSelector)} placeholder="Minute" name={CHANGE_KEYS.START_MINUTE}
                                        value={startMinute ? this.formatSingleValue(startMinute) : null} styles={customDropdownStyles} />
                                    <Select onChange={this.shiftTimeChangeHandler} options={this.formatOptions(this.amPmSelector)} placeholder="am/pm" name={CHANGE_KEYS.START_MERIDIAN}
                                        value={startMeridian ? this.formatSingleValue(startMeridian) : null} styles={customDropdownStyles} />
                                </div>
                            </td>
                            <td>
                                <label>END TIME</label>
                                <div css={rosterStyles.timeSelectionWrapper}>
                                    <Select onChange={this.shiftTimeChangeHandler} options={this.formatOptions(this.hourSelector)} placeholder="Hour" name={CHANGE_KEYS.END_HOUR}
                                        value={endHour ? this.formatSingleValue(endHour) : null} styles={customDropdownStyles} menuPortalTarget={isMobile ? null : document.body} />
                                    <Select onChange={this.shiftTimeChangeHandler} options={this.formatOptions(this.minuteSelector)} placeholder="Minute" name={CHANGE_KEYS.END_MINUTE}
                                        value={endMinute ? this.formatSingleValue(endMinute) : null} styles={customDropdownStyles} />
                                    <Select onChange={this.shiftTimeChangeHandler} options={this.formatOptions(this.amPmSelector)} placeholder="am/pm" name={CHANGE_KEYS.END_MERIDIAN}
                                        value={endMeridian ? this.formatSingleValue(endMeridian) : null} styles={customDropdownStyles} />
                                    {isMobile &&
                                        <img className="delete-btn" src="/images/delete.svg" alt="delete" onClick={(e) => { e.stopPropagation(); this.deleteShift(index) }} />
                                    }
                                </div>
                            </td>
                            {!isMobile &&
                                <td>
                                    <img className="delete-btn top-space" src="/images/delete.svg" alt="delete" onClick={(e) => { e.stopPropagation(); this.deleteShift(index) }} />
                                </td>
                            }
                        </tr>
                        {
                            errMsg &&
                            <tr>
                                <td colSpan={3}>
                                    <div className="warning">{errMsg}</div>
                                </td>
                            </tr>
                        }
                        <tr className="spacer"></tr>
                    </tbody>
                </table>
            </React.Fragment>
        )
    }
}